import { compose, hoistStatics, lifecycle } from 'recompose';
import { translate } from 'react-i18next';
import qs from 'qs';
import { connect } from 'react-redux';
import ModelService from '../../services/social.service';
import AuthService from '../../services/auth.service';
import Social from './Social';
import { userActions } from '../../reducers/user';
import { authActions } from '../../reducers/auth';
import { permissionsActions } from '../../reducers/permissions';
import { settingsActions } from '../../reducers/settings';

const mapStateToProps = state => ({
  user: state.user.user,
  defaultRoute: state.settings.defaultRoute,
});

const mapDispatchToProps = {
  setUser: userActions.setUser,
  setToken: authActions.setToken,
  setPermissions: permissionsActions.setPermissions,
  updateSettings: settingsActions.updateSettings
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  lifecycle({
    async componentDidMount() {
      if (this.props.user) this.props.history.push('/');
      const { setPermissions, setToken, setUser, defaultRoute, updateSettings } = this.props;

      const params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

      if (params.profile) {
        const status = await ModelService.auth(params);

        if (status) {
          this.props.history.push('/profile');
        } else {
          this.props.history.push('/logout');
        }
      } else {
        const { redirect, user, social, token, permissions, enable2faEmail, enable2faSms } = await ModelService.setSocial(params);

        if (enable2faEmail) {
          await updateSettings({ show2faPages: true });
          return this.props.history.push('/check-email');
        }

        if (enable2faSms) {
          await updateSettings({ show2faPages: true });
          return this.props.history.push(`/phone-code/${enable2faSms.id}`);
        }

        if (redirect) {
          window.localStorage.setItem('userEmail', user.email);
          window.localStorage.setItem('social', JSON.stringify(social));

          this.props.history.push('/logout');
        } else if (token && user) {
          await AuthService.setToken(token);
          await setUser({ user });
          await setToken({ token });
          await setPermissions(permissions);

          this.props.history.push(defaultRoute);
        } else {
          this.props.history.push('/logout');
        }
      }
    },
  }),
);

export default hoistStatics(enhance)(Social);



// WEBPACK FOOTER //
// ./src/views/social/index.js